import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { TextInput } from "react-admin";

type JsonInputProps = {
  source: string;
  label: string;
  helperText?: string;
  defaultExpanded?: boolean;
  minRows?: number;
};

export default function JsonInput({ source, label, helperText, defaultExpanded = true, minRows = 8 }: JsonInputProps) {
  return (
    <Accordion defaultExpanded={defaultExpanded} disableGutters elevation={0} variant="outlined">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body2" fontWeight={500}>
          {label}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {helperText && (
          <Typography variant="body2" color="text.secondary" mb={1}>
            {helperText}
          </Typography>
        )}
        <TextInput
          source={source}
          label={false}
          helperText={false}
          fullWidth
          multiline
          minRows={minRows}
          sx={{
            "& .MuiInputBase-input": {
              fontFamily: "monospace",
              fontSize: "0.8rem",
              lineHeight: 1.6,
            },
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
}
